import lodash from 'lodash'

/**
 * 高级查询项
 */
export default class AdvancedSearchOption {
  constructor(fieldType = null, fieldName = null, value = null, operator = '=', label = '') {
    this.fieldType = fieldType
    this.fieldName = fieldName
    this.operator = operator
    this.value = value
    this.label = label
  }

  formatObj2Json() {
    // todo 简洁写法{...this} 待测试
    return { fieldType: this.fieldType, fieldName: this.fieldName, operator: this.operator, value: this.value, label: this.label }
  }

  static parseJson2Obj({ fieldType = null, fieldName = null, value = null, operator = '=', label = '' }) {
    return new AdvancedSearchOption(fieldType, fieldName, value, operator, label)
  }

  static hasField(fieldName, conditions) {
    let eureka = false
    if (Object.prototype.toString.call(conditions) === '[object Array]') {
      eureka = !!conditions.find(item => {
        return item.fieldName === fieldName
      })
    }
    return eureka
  }

  // 更新覆蓋指定項
  static updateOption(option, options) {
    if (Object.prototype.toString.call(options) === '[object Array]') {
      options.forEach(item => {
        if (item.fileName === option.fileName) {
          item = { ...option }
        }
      })
    }
    return options
  }

  /**
   * 获取条件
   */
  static getOption(fieldName, options) {
    let option = null
    if (Object.prototype.toString.call(options) === '[object Array]') {
      option = options.find(item => {
        return item.fieldName === fieldName
      })
      if (option) {
        option = this.parseJson2Obj(option)
      }
    }
    return option
  }

  /**
   * 删除条件
   */
  static removeOption(fieldName, options) {
    let delOption = [null]
    if (this.hasField(fieldName, options)) {
      const option = options.find(item => {
        return item.fieldName === fieldName
      })
      const index = options.indexOf(option)
      if (index > -1) {
        delOption = options.splice(index, 1)
      }
    }
    return delOption[0]
  }
}
